import { useLocales } from '@sevenrooms/locales'
import { VStack } from '@sevenrooms/ui-kit/layout'
import { Link, Text } from '@sevenrooms/ui-kit/typography'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

export interface BookingPolicyProps {
  termsPolicyHolderName: string
  termsOfServiceUrl: string
  customPrivacyPolicyLink?: string
  customPolicyHolderName?: string
  privacyPolicyUrl: string
  privacyPolicyText: string
  showSevenRoomsPolicy?: boolean
  showSmsPolicy?: boolean
}

export function BookingPolicy({
  termsPolicyHolderName,
  termsOfServiceUrl,
  customPrivacyPolicyLink,
  customPolicyHolderName,
  privacyPolicyUrl,
  privacyPolicyText,
  showSevenRoomsPolicy,
  showSmsPolicy,
}: BookingPolicyProps) {
  const { formatMessage } = useLocales()

  return (
    <VStack spacing="m">
      <Text textStyle="body2" data-test="booking-policy-disclaimer" wordBreak="break-word">
        {`${formatMessage(reservationWidgetMessages.resWidgetPolicyDisclaimerText)} ${termsPolicyHolderName} `}
        <Link textStyle="body2" to={termsOfServiceUrl} isExternal data-test="booking-policy-term-service-link">
          {formatMessage(reservationWidgetMessages.resWidgetTermsOfServiceLinkLabel)}
        </Link>
        {showSevenRoomsPolicy && (
          <>
            {` ${formatMessage(reservationWidgetMessages.commonAndText)} `}
            <Link textStyle="body2" to={privacyPolicyUrl} isExternal data-test="booking-policy-privacy-link">
              {privacyPolicyText}
            </Link>
          </>
        )}
        {customPrivacyPolicyLink && (
          <>
            {` ${formatMessage(reservationWidgetMessages.commonAndText)} `}
            <Text textStyle="body2" data-test="booking-policy-custom-privacy">
              {customPolicyHolderName ? `${customPolicyHolderName} ` : null}
              <Link textStyle="body2" to={customPrivacyPolicyLink} isExternal data-test="booking-policy-custom-privacy-link">
                {formatMessage(reservationWidgetMessages.resWidgetCustomPrivacyPolicyLinkLabel)}
              </Link>
            </Text>
          </>
        )}
      </Text>
      {showSmsPolicy && (
        <Text textStyle="body2" data-test="booking-policy-twilio-consent">
          {
            // Remove formatting as we do not want to italicize the text
            formatMessage(reservationWidgetMessages.policyUsTwilioSmsOptInSubfooter, {
              i: (chunks: string) => chunks,
            })
          }
        </Text>
      )}
    </VStack>
  )
}
